import type {
	MenuItemLinks,
	NavBarItem,
	NavBarLinkItem,
	NavBarMenuItem,
	NavCta,
} from '@ds-mgnl/marketing';
import { MdShoppingCart } from '@dsx/react';

export const topNavData: NavBarItem[] = [
	{
		type: 'submenu',
		label: 'Solutions',
		items: [
			{
				type: 'submenu',
				label: 'Advocacy',
				items: [
					{
						type: 'links',
						linkGroups: [
							{
								links: [
									{
										label: 'Senior Living Advocacy',
										description:
											'Protect senior care policy with grassroots, industry-wide advocacy.',
										path: '/solutions/advocacy#sla',
										value: '/solutions/advocacy#sla',
										openInNewTab: false,
									},
									{
										label: 'Tell Our Stories',
										description:
											'Inspire lawmakers with human-centered, uplifting care stories.',
										path: '/solutions/advocacy#stories',
										value: '/solutions/advocacy#stories',
										openInNewTab: false,
									},
									{
										label: 'Direct Supply Partners PAC',
										description:
											'Back policy change with employee-driven, bipartisan support.',
										path: '/solutions/advocacy#ds-pac',
										value: '/solutions/advocacy#ds-pac',
										openInNewTab: false,
									},
								],
							},
						],
					} as MenuItemLinks,
					{
						type: 'divider',
					},
					{
						type: 'links',
						linkGroups: [
							{
								links: [
									{
										label: 'View All Advocacy Solutions',
										path: '/solutions/advocacy',
										value: '/solutions/advocacy',
										openInNewTab: false,
									},
								],
							},
						],
					} as MenuItemLinks,
				],
			} as NavBarMenuItem,
			{
				type: 'submenu',
				label: 'Building Maintenance',
				items: [
					{
						type: 'links',
						linkGroups: [
							{
								columnCount: 2,
								links: [
									{
										label: 'TELS Platform',
										description:
											'Optimize senior living maintenance with smart, centralized control.',
										path: '/solutions/building-maintenance#platform',
										value: '/solutions/building-maintenance#platform',
										openInNewTab: false,
									},
									{
										label: 'Planned Projects',
										description:
											'Execute projects with strategic, start-to-finish support.',
										path: '/solutions/building-maintenance#projects',
										value: '/solutions/building-maintenance#projects',
										openInNewTab: false,
									},
									{
										label: 'Routine & Emergency Repairs',
										description:
											'Optimize senior living maintenance with smart, centralized control.',
										path: '/solutions/building-maintenance#repairs',
										value: '/solutions/building-maintenance#repairs',
										openInNewTab: false,
									},
									{
										label: 'Recurring Maintenance Programs',
										description:
											'Planned maintenance programs save you time, money and headaches.',
										path: '/solutions/building-maintenance#maintenance',
										value: '/solutions/building-maintenance#maintenance',
										openInNewTab: false,
									},
								],
							},
						],
					} as MenuItemLinks,
					{
						type: 'divider',
					},
					{
						type: 'links',
						linkGroups: [
							{
								links: [
									{
										label: 'View All Building Maintenance Solutions',
										path: '/solutions/building-maintenance',
										value: '/solutions/building-maintenance',
										openInNewTab: false,
									},
								],
							},
						],
					} as MenuItemLinks,
				],
			} as NavBarMenuItem,
			{
				type: 'submenu',
				label: 'Design & Procurement',
				items: [
					{
						type: 'links',
						linkGroups: [
							{
								columnCount: 2,
								links: [
									{
										label: 'Plan',
										description:
											'Maximize your renovation and new construction projects',
										path: '/solutions/design-procurement#plan',
										value: '/solutions/design-procurement#plan',
										openInNewTab: false,
									},
									{
										label: 'Design',
										description:
											'Innovative environments that surpass expectations',
										path: '/solutions/design-procurement#design',
										value: '/solutions/design-procurement#design',
										openInNewTab: false,
									},
									{
										label: 'Procure',
										description:
											'Access 200+ brands of furniture, healthcare and operational equipment.',
										path: '/solutions/design-procurement#procure',
										value: '/solutions/design-procurement#procure',
										openInNewTab: false,
									},
									{
										label: 'Construct',
										description:
											'Deliver your refresh, renovation and repositioning projects on time, so your community is ready on opening day.',
										path: '/solutions/design-procurement#construct',
										value: '/solutions/design-procurement#construct',
										openInNewTab: false,
									},
								],
							},
						],
					} as MenuItemLinks,
					{
						type: 'divider',
					},
					{
						type: 'links',
						linkGroups: [
							{
								links: [
									{
										label: 'View All Design & Procurement Solutions',
										path: '/solutions/design-procurement',
										value: '/solutions/design-procurement',
										openInNewTab: false,
									},
								],
							},
						],
					} as MenuItemLinks,
				],
			} as NavBarMenuItem,
			{
				type: 'submenu',
				label: 'Equipment & Furnishings',
				items: [
					{
						type: 'links',
						linkGroups: [
							{
								links: [
									{
										label: 'Shop All Products',
										description: '4000+ brands at competitive prices',
										path: 'https://store.directsupply.com/',
										value: 'https://store.directsupply.com/',
										openInNewTab: true,
									},
								],
							},
						],
					} as MenuItemLinks,
					{ type: 'divider' },
					{
						type: 'links',
						linkGroups: [
							{
								columnCount: 2,
								links: [
									{
										label: 'DS Smart',
										description:
											'Capture vitals with faster, EMR-connected documentation.',
										path: '/solutions/workforce-technology/ds-smart',
										value: '/solutions/workforce-technology/ds-smart',
										openInNewTab: false,
									},
									{
										label: 'Robotics',
										description:
											'Automate tasks with fixed-cost, service-driven tools.',
										path: '/solutions/workforce-technology/robotics',
										value: '/solutions/workforce-technology/robotics',
										openInNewTab: false,
									},
									{
										label: 'Maxwell Thomas',
										description:
											'Furnish with style, safety, and comfort in mind.',
										path: '/solutions/equipment-furnishings/direct-supply-manufacturing#maxwell-thomas',
										value:
											'/solutions/equipment-furnishings/direct-supply-manufacturing#maxwell-thomas',
										openInNewTab: false,
									},
									{
										label: 'Direct Supply Manufacturing',
										description:
											'Deliver better care with reliable, purpose-built products',
										path: '/solutions/equipment-furnishings/direct-supply-manufacturing',
										value:
											'/solutions/equipment-furnishings/direct-supply-manufacturing',
										openInNewTab: false,
									},
								],
							},
						],
					} as MenuItemLinks,
					{
						type: 'divider',
					},
					{
						type: 'links',
						linkGroups: [
							{
								links: [
									{
										label: 'View All Equipment & Furnishings Solutions',
										path: '/solutions/equipment-furnishings',
										value: '/solutions/equipment-furnishings',
										openInNewTab: false,
									},
								],
							},
						],
					} as MenuItemLinks,
				],
			} as NavBarMenuItem,
			{
				type: 'submenu',
				label: 'Professional Services',
				items: [
					{
						type: 'links',
						linkGroups: [
							{
								columnCount: 2,
								links: [
									{
										label: 'Technology Services',
										description:
											'Simplify global sourcing with personal, efficient applied technology solutions.',
										path: '/solutions/professional-services/technology',
										value: '/solutions/professional-services/technology',
										openInNewTab: false,
									},
									{
										label: 'Building Services',
										description:
											'Manage repairs with responsive, nationwide service coverage.',
										path: '/solutions/professional-services#building-services',
										value: '/solutions/professional-services#building-services',
										openInNewTab: false,
									},
									{
										label: 'Procurement Services',
										description:
											'Unlock savings with strategic, contract-based support.',
										path: '/solutions/professional-services#procurement-services',
										value:
											'/solutions/professional-services#procurement-services',
										openInNewTab: false,
									},
									{
										label: 'Design Services',
										description:
											'Simplify renovations with on-trend, seamless support.',
										path: '/solutions/professional-services#design-services',
										value: '/solutions/professional-services#design-services',
										openInNewTab: false,
									},
								],
							},
						],
					} as MenuItemLinks,
					{
						type: 'divider',
					},
					{
						type: 'links',
						linkGroups: [
							{
								links: [
									{
										label: 'View All Professional Services Solutions',
										path: '/solutions/professional-services',
										value: '/solutions/professional-services',
										openInNewTab: false,
									},
								],
							},
						],
					} as MenuItemLinks,
				],
			} as NavBarMenuItem,
			{
				type: 'submenu',
				label: 'Spend Management',
				items: [
					{
						type: 'links',
						linkGroups: [
							{
								links: [
									{
										label: 'DSSI Platform',
										description:
											'Cut costs with smarter, AI-powered purchasing',
										path: '/solutions/spend-management#dssi-platform',
										value: '/solutions/spend-management#dssi-platform',
										openInNewTab: false,
									},
									{
										label: 'Procurement Services',
										description:
											'Unlock senior living procurement savings with strategic, contract-based support.',
										path: '/solutions/spend-management#procurement-services',
										value: '/solutions/spend-management#procurement-services',
										openInNewTab: false,
									},
								],
							},
						],
					} as MenuItemLinks,
					{
						type: 'divider',
					},
					{
						type: 'links',
						linkGroups: [
							{
								links: [
									{
										label: 'View All Spend Management Solutions',
										path: '/solutions/spend-management',
										value: '/solutions/spend-management',
										openInNewTab: false,
									},
								],
							},
						],
					} as MenuItemLinks,
				],
			} as NavBarMenuItem,
			{
				type: 'submenu',
				label: 'Workforce Technology',
				items: [
					{
						type: 'links',
						linkGroups: [
							{
								columnCount: 2,
								links: [
									{
										label: 'DS Smart',
										description:
											'Capture vitals with faster, EMR-connected documentation.',
										path: '/solutions/workforce-technology/ds-smart',
										value: '/solutions/workforce-technology/ds-smart',
										openInNewTab: false,
									},
									{
										label: 'Pac-IQ',
										description:
											'Increase admissions with smarter, faster referral management.',
										path: '/solutions/workforce-technology#pac-iq',
										value: '/solutions/workforce-technology#pac-iq',
										openInNewTab: false,
									},
									{
										label: 'Robotics',
										description:
											'Automate tasks with fixed-cost, service-driven tools.',
										path: '/solutions/workforce-technology/robotics',
										value: '/solutions/workforce-technology/robotics',
										openInNewTab: false,
									},
									{
										label: 'Medical Waste',
										description:
											'Control regulated medical waste costs and compliance risk',
										path: '/solutions/workforce-technology#medical-waste',
										value: '/solutions/workforce-technology#medical-waste',
										openInNewTab: false,
									},
								],
							},
						],
					} as MenuItemLinks,
					{
						type: 'divider',
					},
					{
						type: 'links',
						linkGroups: [
							{
								links: [
									{
										label: 'View All Workforce Technology Solutions',
										path: '/solutions/workforce-technology',
										value: '/solutions/workforce-technology',
										openInNewTab: false,
									},
								],
							},
						],
					} as MenuItemLinks,
				],
			} as NavBarMenuItem,
		],
	} as NavBarMenuItem,
	{
		type: 'submenu',
		label: 'Resources',
		items: [
			{
				type: 'links',
				linkGroups: [
					{
						label: 'Popular Topics',
						links: [
							{
								label: 'Advocacy',
								path: '/resources/topics/advocacy',
								value: '/resources/topics/advocacy',
								openInNewTab: false,
							},
							{
								label: 'AI & Emerging Technology',
								path: '/resources/topics/emerging-technology',
								value: '/resources/topics/emerging-technology',
								openInNewTab: false,
							},
							{
								label: 'Building Maintenance',
								path: '/resources/topics/building-maintenance',
								value: '/resources/topics/building-maintenance',
								openInNewTab: false,
							},
							{
								label: 'Capital Planning',
								path: '/resources/topics/capital-planning',
								value: '/resources/topics/capital-planning',
								openInNewTab: false,
							},
							{
								label: 'Design & Procurement',
								path: '/resources/topics/design-procurement',
								value: '/resources/topics/design-procurement',
								openInNewTab: false,
							},
							{
								label: 'Equipment & Furnishings',
								path: '/resources/topics/equipment-furnishings',
								value: '/resources/topics/equipment-furnishings',
								openInNewTab: false,
							},
							{
								label: 'Spend Management',
								path: '/resources/topics/spend-management',
								value: '/resources/topics/spend-management',
								openInNewTab: false,
							},
						],
					},
					{
						label: 'Resource Types',
						links: [
							{
								label: 'Blog',
								path: '/resources/blogs',
								value: '/resources/blogs',
								openInNewTab: false,
							},
							{
								label: 'Case Studies',
								path: '/resources/case-studies',
								value: '/resources/case-studies',
								openInNewTab: false,
							},
							{
								label: 'Maintenance Guides',
								path: '/resources/maintenance-guides',
								value: '/resources/maintenance-guides',
								openInNewTab: false,
							},
							{
								label: 'Selection Guides',
								path: '/resources/selection-guides',
								value: '/resources/selection-guides',
								openInNewTab: false,
							},
							{
								label: 'Webinars',
								path: '/resources/webinars',
								value: '/resources/webinars',
								openInNewTab: false,
							},
							{
								label: 'White Papers',
								path: '/resources/white-papers',
								value: '/resources/white-papers',
								openInNewTab: false,
							},
						],
					},
				],
			} as MenuItemLinks,
			{
				type: 'divider',
			},
			{
				type: 'links',
				linkGroups: [
					{
						links: [
							{
								label: 'View All Resources',
								path: '/resources',
								value: '/resources',
								openInNewTab: false,
							},
						],
					},
				],
			} as MenuItemLinks,
		],
	} as NavBarMenuItem,
	{
		type: 'submenu',
		label: 'Company',
		items: [
			{
				type: 'links',
				linkGroups: [
					{
						links: [
							{
								label: 'About',
								path: '/company/about',
								value: '/company/about',
								openInNewTab: false,
							},
							{
								label: 'Careers',
								path: '/company/careers',
								value: '/company/careers',
								openInNewTab: false,
							},
							{
								label: 'Innovation',
								path: '/company/innovation',
								value: '/company/innovation',
								openInNewTab: false,
							},
							{
								label: 'Events',
								path: '/events',
								value: '/events',
								openInNewTab: false,
							},
						],
					},
				],
			} as MenuItemLinks,
		],
	} as NavBarMenuItem,
	{
		type: 'link',
		link: {
			label: 'Contact',
			path: '/contact',
			value: '/contact',
			openInNewTab: false,
		},
	} as NavBarLinkItem,
];

export const ctaLinks: NavCta[] = [
	{
		path: 'shop/',
		label: 'Shop',
		value: 'https://store.directsupply.com/',
		icon: MdShoppingCart,
		openInNewTab: false,
	},
];
